import React from 'react'
import { useDispatch } from 'react-redux'
import { useTheme, alpha } from '@mui/material'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid2'
import Button from '@mui/material/Button'
import constants from '../../config/constants'
import useWindowDimensions from './WindowDimesnions'
import defaultTexts from '../../texts/texts'
import { setCookiesStatus } from '../../store/reducers/settingsSlice'

const CookiesPopup = () => {
  const theme = useTheme()
  const { width } = useWindowDimensions()
  const dispatch = useDispatch()

  const wrapperStyle = {
    background: alpha(theme.palette.aliceBlue, 0.9),
    borderRadius: '20px',
    padding: '20px',
    boxShadow: '0px 0px 6px 6px rgba(0, 0, 0, 0.25)',
    position: 'fixed',
    width: width >= constants.lgBreakpoint ? '90%' : '90%',
    left: width >= constants.lgBreakpoint ? '5%' : '5%',
    bottom: '5px',
  }

  const policyTextStyle = {
    fontSize: '14px',
    color: 'black',
  }

  const policyLinkStyle = {
    fontWeight: '500',
    color: 'black',
    fontSize: '14px',
    cursor: 'pointer',

    '&:hover': {
      textDecoration: 'underline',
    },
  }

  const acceptButtonStyle = {
    fontWeight: '500',
    color: 'white',
    background: theme.palette.oxfordBlue,
    fontSize: '18px',
    height: '40px',
    borderRadius: '20px',
    padding: '0px 30px',
    textTransform: 'capitalize',

    '&:hover': {
      background: alpha(theme.palette.oxfordBlue, 0.8),
    },
  }

  const rejectButtonStyle = {
    fontWeight: '500',
    color: 'white',
    background: theme.palette.coralRed,
    fontSize: '18px',
    height: '40px',
    borderRadius: '20px',
    padding: '0px 30px',
    textTransform: 'capitalize',

    '&:hover': {
      background: alpha(theme.palette.coralRed, 0.8),
    },
  }

  const handleClickCookiesPolicy = () => {
    window.open('https://s3.grena.ge/flexostack/67122a81c4a5f8f11711206b/ui-docs/FlexoStack_Privacy_Policy.pdf', '_blank')
  }

  const handleAcceptCookies = () => {
    dispatch(setCookiesStatus({ cookies_status: 'accepted' }))
  }

  const handleRejectCookies = () => {
    dispatch(setCookiesStatus({ cookies_status: 'rejected' }))
  }

  return (
    <Box sx={wrapperStyle}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, lg: 'grow' }}>
          <Box sx={policyTextStyle}>
            <Box component='span'>{defaultTexts.cookiesPopupText} </Box>
            <Box component='span' sx={policyLinkStyle} onClick={handleClickCookiesPolicy}>{defaultTexts.readOurCookiesPolicy}</Box>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, lg: 'auto' }}>
          <Button
            variant='contained'
            disableRipple
            disableElevation
            disabled={false}
            onClick={handleAcceptCookies}
            sx={acceptButtonStyle}
          >
            {defaultTexts.cookiesAcceptLabel}
          </Button>
        </Grid>
        <Grid size={{ xs: 12, lg: 'auto' }}>
          <Button
            variant='contained'
            disableRipple
            disableElevation
            disabled={false}
            onClick={handleRejectCookies}
            sx={rejectButtonStyle}
          >
            {defaultTexts.cookiesRejectLabel}
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}

export default CookiesPopup